import { Process } from "@/services/backend/processes/types/process";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import { Position } from "@/services/backend/htz/position/types/position";
import { v4 } from "uuid";
import {
  Address,
  newAddress,
} from "@/services/backend/addresses/types/address";
import { Contact } from "@/services/backend/contacts/types/contact";
import { Representative } from "@/services/backend/representatives/types/representative";
import { Common } from "@/services/backend/documents/types/common";
import { Immutability } from "@bitory-gmbh/nidavellir";
import { Artefact, Document } from "@bitory-gmbh/bsm";
import { ConfirmationBase } from "@/services/backend/documents/types/confirmation";

export type Confirmation = Document &
  Artefact &
  Immutability &
  Common &
  ConfirmationBase & {
    positions: Position[];
    specialAgreements: string;
    internalComment: string;
    serviceAddress: Address;
    serviceContact: Contact;
  };

export function newConfirmation(
  process: Process,
  branchId: string,
  serviceObjectId: string,
): Confirmation {
  return {
    id: v4(),
    documentKind: GSMDocumentKind.Confirmation,
    processId: process.id,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    immutable: false,
    immutabilityReason: "",
    immutabilitySetAt: undefined,
    immutabilitySetBy: "",
    companyId: process.companyId,
    branchId,
    customerId: process.customerId!,
    serviceObjectId,
    date: new Date().toISOString(),
    orderId: undefined,
    orderDate: undefined,
    orderReference: "",
    offerId: undefined,
    offerDate: undefined,
    offerReference: "",
    positions: [],
    specialAgreements: "",
    internalComment: "",
    postalAddress: newAddress(),
    serviceAddress: newAddress(),
    serviceContact: {
      salutation: "",
      title: "",
      name: "",
      function: "",
      email: "",
      phone: "",
      mobilephone: "",
    } as Contact,
    representative: {
      name: "",
      email: "",
      phone: "",
      mobilephone: "",
    } as Representative,
  };
}

export function updatePostalAddress(
  confirmation: Confirmation,
  address: Address,
): Confirmation {
  return {
    ...confirmation,
    postalAddress: address,
  };
}

export function updateServiceAddress(
  confirmation: Confirmation,
  address: Address,
): Confirmation {
  return {
    ...confirmation,
    serviceAddress: address,
  };
}

export function updateServiceContact(
  confirmation: Confirmation,
  serviceContact: Contact,
): Confirmation {
  return {
    ...confirmation,
    serviceContact,
  };
}

export function updateRepresentative(
  confirmation: Confirmation,
  representative: Representative,
): Confirmation {
  return {
    ...confirmation,
    representative,
  };
}
